import "@cloudscape-design/global-styles/index.css";
import {useContext, useEffect, useState} from "react";
import {getAuthenticationContext} from "../../auth/AuthenticationContext";
import {isEventAuth} from "../../utils/urlUtils";

export const RefreshToken = () => {
  const AuthenticationContext = useContext(getAuthenticationContext());
  const [loginError, setLoginError] = useState(false);

  const login = () => {
    AuthenticationContext.redirectToLogin(isEventAuth() ? "/eventcallback" : "/callback");
  }

  useEffect(() => {
    try {
      login();
    } catch (e) {
      console.log("Failed to redirect user to login: " + e);
      setLoginError(true);
    }
  }, []);

  return (
    loginError ?
      <div className="cq-content">
        <p>
          Your authentication expired.
        </p>
      </div>
      :
      <div className="cq-content">
        <p>
          Your authentication expired. We are redirecting you to authentication
          page.
        </p>
        <p>If you are not automatic redirected please click Login button.</p>
        <div style={{marginTop: "4rem"}}>
          <button type="button" onClick={login} className="cq-button-primary">
            Login
          </button>
        </div>
      </div>
  );
};
